// src/features/logs/accessLogsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: {},
	timeStamp: null,
	loading: false,
	completeLogsData: false,
	error: null
};

const lockersLogsSlice = createSlice({
	name: 'lockersLogs',
	initialState,
	reducers: {
		loadLockersLogs(state) {
			state.loading = true;
			state.error = null;
		},
		loadLockersLogsSuccess(state, action) {
			const { orgID, data, total } = action.payload;

			state.data[orgID] = data;

			state.total = total;
			state.loading = false;
			state.timeStamp = Date.now();
			state.completeLogsData = true;
		},

		loadLockersLogsError(state, action) {
			state.loading = false;
			state.error = action.payload;
		}
	}
});

export const lockersLogsActions = lockersLogsSlice.actions;
export default lockersLogsSlice.reducer;
